import React from 'react';

/**
 * Judul section dengan opsi subtitle dan alignment.
 * @param {string} title - judul (h2)
 * @param {string} subtitle - teks di bawah judul (opsional)
 * @param {string} align - 'left' | 'center'
 * @param {string} titleClassName - class tambahan untuk judul (misal warna)
 * @param {string} className - class untuk wrapper
 */
function SectionTitle({
  title,
  subtitle,
  align = 'left',
  titleClassName = '',
  className = '',
}) {
  const alignClass = align === 'center' ? 'text-center' : '';
  const baseTitle = 'font-bold text-am-text-900';
  const titleClass = [baseTitle, titleClassName].filter(Boolean).join(' ');

  return (
    <div className={`${alignClass} ${className}`.trim()}>
      <h2 className={`text-2xl lg:text-3xl ${titleClass}`.trim()}>{title}</h2>
      {subtitle && <p className="mt-2 text-am-text-700">{subtitle}</p>}
    </div>
  );
}

export default SectionTitle;
